import { Hidden } from '@mui/material';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import InterventionsAsCards from './InterventionsAsCards';
import InterventionsAsTable from './InterventionsAsTable';

class InterventionsList extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let bigScreenElement = <InterventionsAsTable {...this.props} />;

        if (!this.props.interventions.displayAsList)
            bigScreenElement = <InterventionsAsCards {...this.props} />

        return (
            <>
                <Hidden only={['xl', 'lg', 'md']}>
                    <InterventionsAsCards {...this.props} />
                </Hidden>
                <Hidden only={['sm', 'xs']}>
                    {bigScreenElement}
                </Hidden>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        interventions: state.extranetInterventions,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterventionsList);
